export default "__VITE_ASSET__DyDv$ycw__"